import { LoadingContainer } from 'components/loadingContainer'
import { useImageById } from 'hooks/user/useImage'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { BottomSection, CardContainer, MiddleSection, Title, TopSection } from './showCardUser.style'

interface ShowCardUserProps {
    show_id: string
    image: string
    title: string
    description: string
}

export const ShowCardUser: React.FC<ShowCardUserProps> = ({ show_id, image, title, description }) => {
    const { data: imageData, isLoading, error } = useImageById(image.toString())
    const navigate = useNavigate()
    const ref = useRef<HTMLDivElement>(null)
    const [visible, setVisible] = useState(false)

    const handleClick = () => {
        navigate(`/musor/${show_id}`)
    }

    useEffect(() => {
        const handleScroll = () => {
            if (!ref.current) return
            const rect = ref.current.getBoundingClientRect()
            const windowHeight = window.innerHeight

            const isVisible = rect.top < windowHeight * 0.9 && rect.bottom > 0
            setVisible(isVisible)
        }

        window.addEventListener('scroll', handleScroll)
        handleScroll()

        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <CardContainer
            onClick={handleClick}
            ref={ref}
            style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(-5px)' : 'translateY(0)',
                transition: 'opacity 0.4s ease-out, transform 0.4s ease-out',
            }}
        >
            <LoadingContainer isLoading={isLoading} error={error}>
                {imageData && <TopSection $image={imageData.image_url} />}
                <MiddleSection>
                    <Title>{title}</Title>
                </MiddleSection>
                <BottomSection>{description}</BottomSection>
            </LoadingContainer>
        </CardContainer>
    )
}
